import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Box, TablePagination, Button } from '@mui/material';
import { useState } from 'react';
import RemarkPopup from './RemarkPopup';

const columns = [
    { id: 'customerID', label: 'Customer ID', minWidth: 120 },
    { id: 'clientName', label: 'Client Name', minWidth: 170 },
    { id: 'customerLoginUserName', label: 'Login User Name', minWidth: 170 },
    { id: 'phoneNumber', label: 'Phone Number', minWidth: 170 },
    { id: 'createdBy', label: 'Created By', minWidth: 170 },
    { id: 'packageName', label: 'Package Name', minWidth: 170 },
    { id: 'packageStartDate', label: 'Package Start Date', minWidth: 170, type: 'date' },
    { id: 'packageEndDate', label: 'Package End Date', minWidth: 170, type: 'date' },
    { id: 'cappingAmount', label: 'Capping Amount', minWidth: 170 },
    { id: 'cappingProfitAmount', label: 'Capping Profit Amount', minWidth: 170 },
    { id: 'salesAmount', label: 'Sales Amount', minWidth: 170 },
    { id: 'payoutCount', label: 'Payout Count', minWidth: 170 },
    { id: 'totalReferrals', label: 'Total Referrals', minWidth: 170 },
    { id: 'firstFollowUp', label: '1', minWidth: 170 },
    { id: 'secondFollowUp', label: '2', minWidth: 170 },
    { id: 'thirdFollowUp', label: '3', minWidth: 170 },
    { id: 'fourthFollowUp', label: '4', minWidth: 170 },
    { id: 'fifthFollowUp', label: '5', minWidth: 170 }
];

function StickyHeadTable({ reports, filterDate }) {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    return (
        <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '50px' }}>
            <TableContainer sx={{ maxHeight: 440 }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                    {column.label}
                                </TableCell>
                            ))}
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {reports.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                    {columns.map((column) => {
                                        let value = row[column.id];
                                        if (column.type && column.type === 'date') {
                                            if (value) {
                                                const timeString12hr = new Date(
                                                    '1970-01-01T' + value.split('T')[1] + 'Z'
                                                ).toLocaleTimeString('en-US', {
                                                    timeZone: 'UTC',
                                                    hour12: true,
                                                    hour: 'numeric',
                                                    minute: 'numeric',
                                                    second: 'numeric'
                                                });
                                                value = `${value.split('T')[0]} ${timeString12hr}`;
                                            }
                                        }
                                        return (
                                            <TableCell key={column.id} align={column.align}>
                                                {typeof value === 'boolean'
                                                    ? value.toString()
                                                    : column.format && typeof value === 'number'
                                                    ? column.format(value)
                                                    : value}
                                                {/* {column.format && typeof value === 'number' ? column.format(value) : value} */}
                                            </TableCell>
                                        );
                                    })}
                                    <TableCell>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px'
                                            }}
                                        >
                                            <RemarkPopup customerID={row.customerID} dateLabel={filterDate} />
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={reports.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
}

export default StickyHeadTable;
